import React from 'react';

const EntityDBColumns: React.FC = () => {
  return (
    <div className='screening-results-columns'>
      <div className='screening-table-title-column' style={{ flex: '2 0 0' }}>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Name</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Entities</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Cleared</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Flagged</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>High Risk (%)</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Updated</div>
        </div>
      </div>
    </div>
  );
};

export default EntityDBColumns;
